import { render, staticRenderFns } from "./WhiteSection.vue?vue&type=template&id=d9c13e2a&"
var script = {}
import style0 from "./WhiteSection.vue?vue&type=style&index=0&id=d9c13e2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports